module.exports = __webpack_public_path__ + "assets/47dc9d07f5f37ede81ba130fb709c179.jpg";